import { render, staticRenderFns } from "./VerticalTocMenu.vue?vue&type=template&id=f1db4f06&scoped=true&"
import script from "./VerticalTocMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalTocMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTocMenu.vue?vue&type=style&index=0&id=f1db4f06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1db4f06",
  null
  
)

export default component.exports